// extracted by mini-css-extract-plugin
export default {"EmptyTable":"EmptyTableDark__EmptyTable___e78Gs"};